export const buildSafeCanonicalUrl = (
  baseUrl: string,
  path: string,
): string => {
  try {
    const url = new URL(path, baseUrl);
    if (url.protocol === 'http:' || url.protocol === 'https:') {
      return url.toString().toLowerCase();
    }
    return new URL('/', baseUrl).toString().toLowerCase();
  } catch (e) {
    return '/';
  }
};
